<template>
  <div>
    <!-- <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Név <span v-if="selectable" class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required"
        :name="`biztositott_nev_${listName}_${pKey}`"
        v-slot="{errors, classes}"
        class="col-sm-8"
        v-if="selectable"
      >
        <input
          class="form-control"
          type="text"
          v-model="name"
          :id="`biztositott_nev_${listName}_${pKey}`"
          :class="classes"
          required
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
      <div class="col-sm-8" v-else>
        {{ name }}
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4" :for="`biztositott_nev_${listName}_${pKey}`"
        >Születési dátum <span v-if="selectable" class="text-danger">*</span></label
      >
      <div class="col-sm-8" v-if="selectable">
        <Datepicker
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="disabledDates"
          :typeable="false"
          v-model="bornDate"
          :bootstrap-styling="true"
          :required="true"
        ></Datepicker>
        <ValidationProvider
          :immediate="true"
          rules="required|szuletes_datum"
          :name="`biztositott_szul_${listName}_${pKey}`"
          v-slot="{errors}"
        >
          <input type="text" :value="bornDate" disabled hidden />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="col-sm-8" v-else>
        {{ new Date(bornDate).toLocaleDateString('hu-HU') }}
      </div>
    </div>
    <div class="form-group row" v-if="selectable">
      <label class="col-sm-4">
        Biztosított törlése<br />
        <span class="text-danger fw-normal">A törléssel a beírt adatok elvesznek.</span>
      </label>
      <div class="col-sm-8">
        <div class="btn btn-red w-100" @click="deleteInsuredPerson">Törlés</div>
      </div>
    </div> -->
    <div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" :for="`jelzalog_hitelezo_azon_${pKey + 2}`"
          >Hitelező cég neve: <span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          name="mező"
          class="col-sm-4"
        >
          <select
            class="form-select dark-border"
            :name="`jelzalog_hitelezo_azon_${pKey + 2}`"
            :id="`jelzalog_hitelezo_azon_${pKey + 2}`"
            :class="classes"
            v-model="mortgageBank"
          >
            <option :value="null">Kérem válasszon</option>
            <option :value="'0000000000'">Manuálisan megadom</option>
            <option :value="bank.id" v-for="(bank, key) in banks" :key="key">
              {{ bank.name }}
            </option>
          </select>
          <small
            id="jelzalog_hitelezo_azon-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-sm-4"
        >
          <input
            :aria-label="`${pKey + 2}. jelzálog hitelező név`"
            type="text"
            class="form-control dark-border"
            :id="`jelzalog_hitelezo_nev_${pKey + 2}`"
            :name="`jelzalog_hitelezo_nev_${pKey + 2}`"
            v-model="mortgageCreditor"
            :class="classes"
            :readonly="mortgageBank != '0000000000'"
          />
          <small
            id="jelzalog_hitelezo_nev-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" :for="`jelzalog_hitelezo_szekhely_${pKey + 2}`"
          >Hitelező cég székhelye:<span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          name="mező"
          class="col-sm-8"
        >
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control dark-border"
              :id="`jelzalog_hitelezo_szekhely_${pKey + 2}`"
              :name="`jelzalog_hitelezo_szekhely_${pKey + 2}`"
              v-model="mortgageCreditorLocation"
            />
          </div>
          <small
            id="jelzalog_hitelezo_szekhely-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3" v-if="!this.$store.state.dm">
        <label class="col-sm-4" :for="`jelzalog_hitel_tipusa_${pKey + 2}`"
          >Hitelszerződés típusa: <span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          name="mező"
          class="col-sm-8"
        >
          <select
            class="form-select dark-border"
            :name="`jelzalog_hitel_tipusa_${pKey + 2}`"
            :id="`jelzalog_hitel_tipusa_${pKey + 2}`"
            :class="classes"
            v-model="mortgageType"
          >
            <option :value="null">Kérem válasszon</option>

            <option v-for="(label, id) in mortgagetypes" :key="id" :value="id">
              {{ label }}
            </option>
          </select>
          <small
            id="jelzalog_hitel_tipusa-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3" v-if="this.$store.state.dm">
        <label class="col-sm-4" :for="`jelzalog_azonosito_${pKey + 2}`"
          >Hitelszerződés azonosítója:</label
        >
        <ValidationProvider v-slot="{ errors, classes }" class="col-sm-8">
          <input
            type="text"
            class="form-control dark-border"
            :id="`jelzalog_azonosito_${pKey + 2}`"
            :name="`jelzalog_azonosito_${pKey + 2}`"
            :class="classes"
            v-model="mortgageId"
          />
          <small
            id="jelzalog_azonosito-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3" v-if="!this.$store.state.dm">
        <label class="col-sm-4" :for="`jelzalog_azonosito_${pKey + 2}`"
          >Hitelszerződés azonosítója: <span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <input
            type="text"
            class="form-control dark-border"
            :id="`jelzalog_azonosito_${pKey + 2}`"
            :name="`jelzalog_azonosito_${pKey + 2}`"
            :class="classes"
            v-model="mortgageId"
          />
          <small
            id="jelzalog_azonosito-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="form-group row mb-3" v-if="this.$store.state.dm">
        <label class="col-sm-4" :for="`jelzalog_hitel_osszeg_${pKey + 2}`"
          >Hitel összege és devizaneme:</label
        >
        <ValidationProvider v-slot="{ errors, classes }" class="col-sm-6">
          <input
            type="text"
            class="form-control dark-border"
            :id="`jelzalog_hitel_osszeg_${pKey + 2}`"
            :name="`jelzalog_hitel_osszeg_${pKey + 2}`"
            :class="classes"
            v-model="mortgagePrice"
          />
          <small
            id="jelzalog_hitel_osszeg-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
        <div class="col-sm-2">
          <select
            :aria-label="`${pKey + 2}. jelzálog hitel deviza`"
            :name="`jelzalog_hitel_deviza_${pKey + 2}`"
            :id="`jelzalog_hitel_deviza_${pKey + 2}`"
            class="form-select dark-border"
            v-model="mortgageCurrency"
          >
            <option :value="null">Nincs kiválasztva</option>
            <option value="AUD">AUD</option>
            <option value="CAD">CAD</option>
            <option value="CHF">CHF</option>
            <option value="CZK">CZK</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="HRK">HRK</option>
            <option value="HUF">HUF</option>
            <option value="PLN">PLN</option>
            <option value="RON">RON</option>
            <option value="SEK">SEK</option>
            <option value="TRY">TRY</option>
            <option value="USD">USD</option>
          </select>
        </div>
      </div>
      <div class="form-group row mb-3" v-if="!this.$store.state.dm">
        <label class="col-sm-4" :for="`jelzalog_hitel_osszeg_${pKey + 2}`"
          >Hitel összege és devizaneme:
          <span class="text-danger">*</span></label
        >
        <ValidationProvider
          rules="required|min_value:1"
          v-slot="{ errors, classes }"
          class="col-sm-6"
        >
          <input
            type="text"
            class="form-control dark-border"
            :id="`jelzalog_hitel_osszeg_${pKey + 2}`"
            :name="`jelzalog_hitel_osszeg_${pKey + 2}`"
            :class="classes"
            v-model="mortgagePrice"
          />
          <small
            id="jelzalog_hitel_osszeg-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
        <div class="col-sm-2">
          <select
            :aria-label="`${pKey + 2}. jelzálog hitel deviza`"
            :name="`jelzalog_hitel_deviza_${pKey + 2}`"
            :id="`jelzalog_hitel_deviza_${pKey + 2}`"
            class="form-select dark-border"
            v-model="mortgageCurrency"
          >
            <option :value="null">Nincs kiválasztva</option>
            <option value="AUD">AUD</option>
            <option value="CAD">CAD</option>
            <option value="CHF">CHF</option>
            <option value="CZK">CZK</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="HRK">HRK</option>
            <option value="HUF">HUF</option>
            <option value="PLN">PLN</option>
            <option value="RON">RON</option>
            <option value="SEK">SEK</option>
            <option value="TRY">TRY</option>
            <option value="USD">USD</option>
          </select>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" :for="`jelzalog_hitel_kezdete_${pKey + 2}`"
          >Hitel kezdete:</label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            :id="`jelzalog_hitel_kezdete_${pKey + 2}`"
            :name="`jelzalog_hitel_kezdete_${pKey + 2}`"
            type="date"
            min="1900-01-01"
            max="9999-12-31"
            v-model="mortgageStartDate"
            required
          />
          <!-- <Datepicker
            id="jelzalog_hitel_kezdete"
            name="jelzalog_hitel_kezdete"
            :format="'yyyy-MM-dd'"
            :placeholder="'ÉÉÉÉ-HH-NN'"
            :language="hu"
            :typeable="true"
            input-class="form-control"
            v-model="mortgageStartDate"
          ></Datepicker> -->
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4" :for="`jelzalog_hitel_lejarat_${pKey + 2}`"
          >Hitel lejárata:</label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            :id="`jelzalog_hitel_lejarat_${pKey + 2}`"
            :name="`jelzalog_hitel_lejarat_${pKey + 2}`"
            type="date"
            min="1900-01-01"
            max="9999-12-31"
            v-model="mortgageEndDate"
            required
          />
          <!-- <Datepicker
            id="jelzalog_hitel_lejarat"
            name="jelzalog_hitel_lejarat"
            :format="'yyyy-MM-dd'"
            :placeholder="'ÉÉÉÉ-HH-NN'"
            :language="hu"
            :typeable="true"
            input-class="form-control"
            v-bind:value="mortgageEndDate"
          ></Datepicker> -->
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">
        Jelzálog törlése<br />
        <span class="text-danger fw-normal"
          >A törléssel a beírt adatok elvesznek.</span
        >
      </label>
      <div class="col-sm-8 my-3">
        <button type="button" class="btn btn-red w-100" @click="deleteMortgage">
          Törlés
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { hu } from "vuejs-datepicker/dist/locale";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["pKey", "mortgage", "selectable", "listName"],
  components: {
    Datepicker,
  },
  data() {
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    );
    const minDate = new Date(today);
    // minDate.setFullYear(now.getFullYear() - 70);
    // minDate.setMonth(now.getMonth());
    // minDate.setDate(now.getDate() + 1);
    minDate.setFullYear(1900);
    if (this.listName === "travelInsuranced")
      minDate.setFullYear(now.getFullYear() - 70);
    if (this.listName === "burialInsuranced")
      minDate.setFullYear(now.getFullYear() - 65);
    minDate.setMonth(1);
    minDate.setDate(1);

    return {
      hu: hu,
      //mortgageBank: null,
      disabledDates: {
        customPredictor: function(date) {
          return date > today || date < minDate;
        },
      },
    };
  },
  computed: {
    ...mapFields(["banks", "mortgagetypes"]),
    // mortgageBank: {
    //   get() {
    //     return this.$store.state.chooseableAccesories[this.listName].list[this.pKey].name;
    //   },
    //   set(value) {
    //     this.$store.commit('updateMortgage', {
    //       index: this.pKey,
    //       key: 'mortgageBank',
    //       value: value,
    //       listName: this.listName,
    //     });
    //   },
    // },
    mortgageBank: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageBank;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageBank",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageCreditor: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].creditor;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "creditor",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageCreditorLocation: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].creditorLocation;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "creditorLocation",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageId: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageId;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageId",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageType: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageType;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageType",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgagePrice: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgagePrice;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgagePrice",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageCurrency: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageCurrency;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageCurrency",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageStartDate: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageStartDate;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageStartDate",
          value: value,
          listName: this.listName,
        });
      },
    },
    mortgageEndDate: {
      get() {
        return this.$store.state.chooseableAccesories[this.listName].list[
          this.pKey
        ].mortgageEndDate;
      },
      set(value) {
        this.$store.commit("updateMortgage", {
          index: this.pKey,
          key: "mortgageEndDate",
          value: value,
          listName: this.listName,
        });
      },
    },
  },
  methods: {
    deleteMortgage() {
      // if (!this.selectable) return;
      this.$store.commit("deleteMortgage", {
        id: this.pKey,
        listName: this.listName,
      });
    },
  },
  watch: {
    mortgageBank: function(newVal, oldVal) {
      const bank = this.banks.find((bank) => bank.id === newVal);
      if (bank) {
        this.mortgageCreditor = bank.name;
        if (bank.address) {
          this.mortgageCreditorLocation = bank.address.replaceAll(",", "");
        } else {
          this.mortgageCreditorLocation = bank.address;
        }
      } else {
        if (newVal == "0000000000") {
          //
        } else {
          this.mortgageBank = null;
        }
        this.mortgageCreditor = "";
        this.mortgageCreditorLocation = "";
      }
    },
    mortgageCreditorLocation: function(newVal) {
      if (newVal) {
        this.mortgageCreditorLocation = newVal.replaceAll(",", "");
      } else {
        this.mortgageCreditorLocation = newVal;
      }
    },
  },
};
</script>
